export default __webpack_public_path__ + "static/media/building.80092068.jpg";